export enum AccountType{
    OPERATION='operations',
    NATION='nation',
    SUPPORT='support',
    DISTRIBUTOR='distributeur',
}